import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UnitxAngularChatbotComponentComponent } from './unitx-angular-chatbot-component.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatListModule,} from '@angular/material/list';
import { ReactiveFormsModule } from '@angular/forms';
import {MatDividerModule} from '@angular/material/divider';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MessageComponent } from './message/message.component';
import {MatTooltipModule} from '@angular/material/tooltip'


@NgModule({
  declarations: [UnitxAngularChatbotComponentComponent,MessageComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatGridListModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatInputModule,
    MatFormFieldModule,
    MatListModule,
    MatTooltipModule
    
  ],
  exports: [UnitxAngularChatbotComponentComponent]
})
export class UnitxAngularChatbotComponentModule { }
